import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import PublicAnnoncements from "./PublicAnnoncements";
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";

const PublicAnnoncementsMain = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('Public_Announcements')}
          fileName="Public Announcements"
          showmenu={true}
          showdownload={false}
          showIconsForback={false}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <PublicAnnoncements />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default PublicAnnoncementsMain;